import { Box, Button, Card, Grid, IconButton, MenuItem, Select, Tooltip } from "@mui/material";
import { WBInput, WBSelect } from "components/_WBcomponents/WBInput";
import React, { useEffect, useState } from "react";
import { WBLabel } from "components/_WBcomponents/WBLabel";
import { NumericFormat } from "react-number-format";
import { getEventList } from "services/eventService";
import DropZoneComponent from "components/_WBcomponents/DropzoneComponent";
import { handleUpload } from "helper/S3";
import { createProduct, getProductDetail, updateProduct } from "services/productService";
import { DeleteOutline } from "@mui/icons-material";

function ProductForm ({
    id,
    loadData
}) {

    const [ form, setForm ] = useState({
        skuId: "",
        name: "",
        image: "",
        event: null,
        description: "",
        stock: "",
        price: "",
        qtyType: "",
        productVariantPrice: null,
        isActive: true
    })

    const [ events, setEvents ] = useState([])
    const [ loading, setLoading ] = useState(false)

    useEffect(() => {
        loadEvents()
    }, [])

    useEffect(() => {
        if (id) { 
            loadProductDetailInfo()
         }
    }, [id])

    useEffect(() => { console.log('here form', form) }, [form])

    const loadProductDetailInfo = async () => {
        let { data, error } = await getProductDetail({
            id
        })
        if (data) { 
            setForm(prev => ({
                ...prev,
                ...data,
                event: { value: data.event._id, label: data.event.eventName }
            }))
        }
    }

    const onChange = (e) => {
        setForm((prev) => ({
            ...prev,
            ...e
        }))
    }

    const loadEvents = async () => {
        let { data, error } = await getEventList({ type: 'po' })
        if (error) { console.log(error) }
        if (data) { 
            setEvents(data.map(v => {
                return {
                    value: v._id,
                    label: v.eventName
                }
            }))
        }
    }

    const deleteAddonImages = (index) => {
        // let currImages = form.itemImages
        // currImages.splice(index, 1);
        onChange({ image: null })
    }

    const saveProduct = async () => {
        setLoading(true)
        try {
            let images = ""
            if (form.image.name) {
                images = await handleUpload({
                    selectedFile: form.image,
                    dirName: 'product'
                })
            } else {
                images = [form.image]
            }
            if (id) {
                let { data, error } = await updateProduct({
                    ...form,
                    _id: id,
                    event: form.event ? form.event.value : '',
                    image: images[0]
                })
            } else {
                let { data, error } = await createProduct({
                    ...form,
                    event: form.event ? form.event.value : '',
                    image: images[0]
                })
            }
            loadData()
            setLoading(false)
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    return (
        <Grid container xs={12} lg={12} p={2} pt={0} spacing={1}>
            {/* <Grid item xs={6} lg={6} spacing={1}>
                <Grid item xs={12}>
                    <WBInput label={"Sku"} onChange={(e) => {
                        onChange({skuId: e.currentTarget.value})
                    }} value={form.skuId}/>
                </Grid>
            </Grid> */}
            <Grid item xs={12} lg={12} spacing={1}>
                <Grid item xs={12}>
                    <WBInput label={"Product Name"} onChange={(e) => {
                        onChange({name: e.currentTarget.value})
                    }} value={form.name}/>
                </Grid>
            </Grid>
            <Grid item xs={12} lg={12} spacing={1}>
                <Grid item xs={12}>
                    <WBSelect label={"PO Event"} inDialog={true} options={events} onChange={(e) => {
                        onChange({ event: e })
                    }} value={form.event}/>
                </Grid>
            </Grid>
            <Grid item xs={12} lg={12} spacing={1}>
                <Grid item xs={12}>
                    <WBInput type={"textarea"} label={"Description"} onChange={(e) => {
                        onChange({description: e.currentTarget.value})
                    }} value={form.description}/>
                </Grid>
            </Grid>
            <Grid item xs={6} md={3}>
                <WBLabel style={{
                    color: "rgb(133, 133, 133)"
                }}>Stock</WBLabel>
                <NumericFormat value={form.stock}
                    isAllowed={(values) => {
                        const {floatValue} = values;
                        // if (form.couponType.value == "percentage") { 
                        //     if (floatValue > 100) { return false }
                        // }
                        return true
                    }}
                    onValueChange={(values) => {
                        const {formattedValue, value, floatValue} = values;
                        // do something with floatValue
                        onChange({ 
                            stock: value.replace(/^0+/, ''),
                        })
                    }}
                    // disabled={form._id}
                    decimalScale={0}
                    allowLeadingZeros={false}
                    allowedDecimalSeparators={false}
                    allowNegative={false}
                    thousandSeparator
                    customInput={WBInput}
                />
            </Grid>
            <Grid item xs={4} md={3}>
                {/* <WBInput styles={{
                    marginTop: 2.5
                }} onChange={(e) => {
                    onChangeShopping({type: e.currentTarget.value})
                }}  value={shoppingRequest.type}/> */}
                <Select 
                    sx={{
                        marginTop: 2.2,
                        borderRadius: 2,
                        height: 41,
                        minWidth: 80,
                        "& .MuiOutlinedInput-root": {
                            "&.Mui-focused fieldset": {
                                borderColor: "#2196f3", // #d8f0e9 #64a591
                            },
                            "&:hover fieldset": {
                                borderColor: '#2196f3',
                            },
                            "&.Mui-disabled input": {
                                backgroundColor: "#f5f5f5"
                            }
                        },
                    }}
                    value={form.qtyType}
                    onChange={(e) => {
                        console.log(e)
                        onChange({qtyType: e.target.value})
                    }}
                    // input={<WBInput />}
                >
                    {["kg", "pcs"].map((name) => (
                        <MenuItem key={name} value={name}>
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </Grid>
            <Grid item xs={12} md={6}>
                <WBLabel style={{
                    color: "rgb(133, 133, 133)"
                }}>Price {form.qtyType ? `/${form.qtyType}` : ''}</WBLabel>
                <NumericFormat value={form.price}
                    isAllowed={(values) => {
                        const {floatValue} = values;
                        // if (form.couponType.value == "percentage") { 
                        //     if (floatValue > 100) { return false }
                        // }
                        return true
                    }}
                    onValueChange={(values) => {
                        const {formattedValue, value, floatValue} = values;
                        // do something with floatValue
                        onChange({ 
                            price: value.replace(/^0+/, ''),
                        })
                    }}
                    // disabled={form._id}
                    decimalScale={0}
                    allowLeadingZeros={false}
                    allowedDecimalSeparators={false}
                    allowNegative={false}
                    thousandSeparator
                    customInput={WBInput}
                />
            </Grid>
            <Grid item xs={12} md={12}>
                <WBLabel bold>Price Variant <span style={{fontSize: 10, color: '#f3278b', cursor: 'pointer'}} onClick={() => {
                    let productPriceVariant = form.productVariantPrice || []
                    if (productPriceVariant.length == 0) { productPriceVariant=[{
                        information: "",
                        price: null,
                    }] } else {
                        productPriceVariant.push({
                            information: "",
                            price: null,
                        })
                    }
                    onChange({ productVariantPrice: productPriceVariant })
                }}>Add</span></WBLabel>
                <Grid container gap={1}>
                    {
                        form.productVariantPrice && form.productVariantPrice.map((v, index) => {
                            return (
                                <Grid item xs={12}>
                                    <Card>
                                        <ProductPrice 
                                            value={v}
                                            onChangePrice={(e) => {
                                                let productInfo = [...form.productVariantPrice]
                                                productInfo[index] = e
                                                console.log('here productInfo', e, productInfo)
                                                onChange({ productVariantPrice: [...productInfo] })
                                            }}
                                            onDelete={() => {
                                                let productInfo = [...form.productVariantPrice]
                                                productInfo.splice(index, 1)
                                                console.log('here productInfo', productInfo)
                                                onChange({ productVariantPrice: [...productInfo] })
                                            }}/>
                                    </Card>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Grid>
            <Grid item mt={1} xs={12} md={12}>
                <WBLabel bold>Upload Image</WBLabel>
                <DropZoneComponent
                    className="drop-zone"
                    uploadName='addonImage'
                    file={form.image}
                    isMultiple={true}
                    onDrop={(files, event) => {
                        onChange({ image: files[0] })
                    }}
                >
                    <div className='dropzone mb-0' style={{
                    textAlign: 'center',
                    minHeight: '150px'
                    }}>
                    <div style={{ padding: 10, alignItems: 'center' }}>
                        <label>
                        <i className='fa fa-upload mr-1' />
                        Drop itemImages to upload
                        </label>
                        <br />
                        <label
                        htmlFor={"addonImage"}
                        style={{ cursor: 'pointer' }}
                        className='dropzone-child mb-0'>
                        or Click to Browse
                        </label>
                        <div style={{ overflowX: 'auto' }}>
                            {
                                form.image &&
                                <div style={{ textAlign: 'left' }}>
                                    Uploaded file :
                                    <div key={`${form.image.name}`} className='d-flex mb-1' style={{ textAlign: 'left' }}>
                                        <img src={(!form.image.name && form.image.includes("https")) ? form.image : URL.createObjectURL(form.image)} style={{ minWidth: '100px', maxHeight: '50px', objectFit: 'contain' }}
                                            onClick={() => {
                                            }}
                                        />
                                        <label className='mt-1 mb-0 ml-1' style={{ alignItems: 'flex-end' }}>
                                            {form.image.name}
                                            <span style={{ marginLeft: 5, color: 'gray', cursor: 'pointer' }} onClick={() => {
                                                deleteAddonImages()
                                            }}>X</span>
                                        </label>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    </div>
                </DropZoneComponent>
            </Grid>
            <Grid item xs={12} md={12} textAlign={"right"}>
                <Button variant="contained" 
                disabled={
                    !form.name ||
                    // !form.skuId ||
                    !form.stock || 
                    !form.price ||
                    !form.qtyType ||
                    !form.event ||
                    loading
                }
                onClick={() => {
                    saveProduct()
                }}>Save</Button>
            </Grid>
        </Grid>
    )
}

function ProductPrice ({
    value,
    onChangePrice,
    onDelete
}) {
    const [ form, setForm ] = useState({
        information: '',
        price: null
    })

    useEffect(() => {
        if (value) {
            console.log('here value', value, form)
            if (value.information !== form.information || value.price !== form.price) { 
                setForm(value)
            }
        }
    }, [value])

    const onChange = (e) => {
        setForm(prev => ({
            ...prev,
            ...e
        }))
        onChangePrice({
            ...form,
            ...e
        })
    }

    return (
        <Box sx={{ position: "relative" }}>
            {/* Top-right delete */}
            <Tooltip title="Delete">
                <IconButton
                    aria-label="delete"
                    onClick={() => {
                        onDelete() // implement onDelete
                    }}
                    sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        zIndex: 1,
                        color: 'black'
                    }}
                    // disabled={!form._id} // optional: only enable when it exists
                    >
                    <DeleteOutline />
                </IconButton>
            </Tooltip>

            {/* Your existing content */}
            <Grid container p={2} gap={1}>
                <Grid item xs>
                    <WBInput label={"Info"} value={form.information} onChange={(e) => {
                        onChange({ information: e.currentTarget.value })
                    }}/>
                </Grid>
                <Grid item xs>
                    <WBLabel style={{ color: "rgb(133, 133, 133)" }}>Price</WBLabel>
                    <NumericFormat
                        value={form.price}
                        isAllowed={(values) => {
                            const { floatValue } = values;
                            return true;
                        }}
                        onValueChange={(values) => {
                            const { value } = values;
                            onChange({
                                price: value.replace(/^0+/, ""),
                            });
                        }}
                        decimalScale={0}
                        allowLeadingZeros={false}
                        allowedDecimalSeparators={false}
                        allowNegative={false}
                        thousandSeparator
                        customInput={WBInput}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default ProductForm